import React, { useEffect, useState } from 'react';
import { postGitHubAccessToken } from '../../utils/api.service';

const GitHubCallback = () => {
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Processing GitHub authentication...');

  // Toggle between backend API and local server
  const USE_BACKEND_API = true; // Set to true to use backend API instead of local server

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');

        if (error) {
          setStatus('error');
          setMessage(`GitHub OAuth error: ${error}`);
          return;
        }

        if (!code) {
          setStatus('error');
          setMessage('No authorization code received from GitHub');
          return;
        }

        if (USE_BACKEND_API) {
          // Backend API approach - call your endpoint for token exchange
          invokeApiGateway(code);
        } else {
          // Local server approach (current)
          invokeLocalServer(code);
        }

      } catch (error) {
        console.error('GitHub OAuth error:', error);
        setStatus('error');
        setMessage(`Authentication failed: ${error.message}`);
      }
    };

    const invokeApiGateway = async (code) => {
      try {
        console.log('🔄 Calling backend API for GitHub token exchange...');
        
        const response = await postGitHubAccessToken({
          code: code,
        });

        if (response && response.data) {
          const { access_token, token_type, scope } = response.data;
          
          if (access_token) {
            handleSuccessfulAuth({
              access_token,
              token_type,
              scope
            });
          } else {
            setStatus('error');
            setMessage('Authentication failed: No access token received');
          }
        } else {
          setStatus('error');
          setMessage('Authentication failed: Invalid response from server');
        }
      } catch (error) {
        console.error('Backend API error:', error);
        setStatus('error');
        setMessage(`Authentication failed: ${error.message}`);
      }
    };

    const invokeLocalServer = async (code) => {
      try {
        // Send code to local server to exchange for access token
        const response = await fetch('http://localhost:3001/api/github/callback', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ code }),
        });

        const data = await response.json();

        if (response.ok && data.access_token) {
          handleSuccessfulAuth(data);
        } else {
          setStatus('error');
          setMessage('Failed to get access token');
        }
      } catch (error) {
        console.error('Local server error:', error);
        setStatus('error');
        setMessage(`Authentication failed: ${error.message}`);
      }
    };

    const handleSuccessfulAuth = (payload) => {
      console.log('🎉 GitHub Access Token:', payload.access_token);
      console.log('Token Type:', payload.token_type);
      console.log('Scope:', payload.scope);

      // Save token to sessionStorage
      sessionStorage.setItem('github_access_token', payload.access_token);

      setStatus('success');
      setMessage(`✅ GitHub authenticated successfully! Redirecting to hosting...`);

      // Redirect back to hosting after a short delay
      setTimeout(() => {
        window.location.href = '/hosting';
      }, 2000);
    };

    handleCallback();
  }, []);

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2>GitHub OAuth Callback</h2>
      <p>{message}</p>
      <small style={{ color: '#666' }}>
        Using: {USE_BACKEND_API ? 'Backend API' : 'Local Server'} • sessionStorage
      </small>

      {status === 'success' && (
        <div>
          <p>✅ Access token saved! Redirecting to Hosting. Please open your Project to import Test Cases from Git Repository.</p>
        </div>
      )}

      {status === 'error' && (
        <button onClick={() => window.location.href = '/hosting'}>
          Back to Hosting
        </button>
      )}
    </div>
  );
};

export default GitHubCallback; 